import {Box, Typography} from "@mui/material";
import type {PromptSlotKind} from "../../utils/promptPlaceholders";
import type {SupplierPickerSelection} from "../AgentTemplates/menus/SupplierTree.ts";
import {SupplierMenu} from "../AgentTemplates/menus/SupplierMenu.tsx";
import {ENTITY_PICKER_MENU_COMPONENTS} from "./EntityPickerMenu.tsx";

/** Entity kinds with a dedicated picker panel (slash flow + entity chips). */
export type SlashRootKind =
    | "supplier"
    | "category"
    | "material"
    | "plant"
    | "cost_center";

export type EntityPickerMenuProps = {
    onApply: (values: string[] | SupplierPickerSelection[]) => void;
    /** Optional header (e.g. from `menuTitleForSlotKind` on entity chips). */
    menuTitle?: string;
    /** Pre-fill picker when editing existing chips (e.g. supplier `s_name` list). */
    initialSelectedValues?: readonly string[];
};

export function SupplierPickerPanel({
                                        onApply,
                                        initialSelectedValues,
                                    }: EntityPickerMenuProps) {
    return (
        <SupplierMenu
            onSupplierSelect={onApply}
            initialSupplierNames={initialSelectedValues}
        />
    );
}

/**
 * Stub until a real picker is implemented for this kind.
 * Replace the entry in `ENTITY_PICKER_MENU_COMPONENTS` when ready.
 */
export function PlaceholderEntityPickerMenu({
                                                kindLabel,
                                                menuTitle,
                                                onApply: _onApply,
                                                initialSelectedValues: _initialSelectedValues,
                                            }: EntityPickerMenuProps & {kindLabel: string}) {
    void _onApply;
    void _initialSelectedValues;
    return (
        <Box sx={{p: 2, minWidth: 220}}>
            <Typography variant="subtitle2">{menuTitle ?? kindLabel}</Typography>
            <Typography variant="caption" color="text.secondary" sx={{display: "block", mt: 0.5}}>
                Picker coming soon
            </Typography>
        </Box>
    );
}


export function isSlashPickerKind(
    kind: PromptSlotKind | null,
): kind is SlashRootKind {
    return (
        kind != null &&
        Object.prototype.hasOwnProperty.call(ENTITY_PICKER_MENU_COMPONENTS, kind)
    );
}
